import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {API_URL} from './token.service';

import 'rxjs/add/operator/filter';

@Injectable()
export class _RuleNettingPriorityService{

  constructor(private http: HttpClient){ }

  getNettingPriorities(ruleType){
    return this.http.get<any[]>(`${API_URL}/rule-netting-priorities/rule-type/` + ruleType).toPromise().then(function(response){
      return response;
    });
  }

  createNettingPriority(ruleNettingPriority){
    return this.http.post(`${API_URL}/rule-netting-priorities`, [ ruleNettingPriority ]);
  }

  updateNettingPriority(ruleNettingPriority){
    return this.http.put(`${API_URL}/rule-netting-priorities`, [ ruleNettingPriority ]);
  }

  deleteNettingPriority(ruleNettingPriorityId){
    return this.http.delete(`${API_URL}/rule-netting-priorities/` + ruleNettingPriorityId);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/ruleNettingPriority.service.ts